import React from 'react';

import { ErrorLoadPageIcon } from '@evinced-private/ui-common';

import { ContactUsButton } from 'src/common/components/contact-us/ContactUsButton';
import { ProductType } from 'src/common/interfaces/Tenant';

import {
	DASHBOARD_ERROR_MSG,
	DASHBOARD_ERROR_TITLE
} from '../../../../common/pages/dashboards-container/errorMessages';
import { LoadErrorMsgLayout } from '../../../../common/pages/property/LoadErrorMsgLayout';

import './WfaError.scss';

interface WfaErrorProps {
	mainTitle?: string;
	secondaryMsg?: string;
	button?: React.ReactElement;
	icon?: string;
	hideButton?: boolean;
}
export const WfaError: React.FC<WfaErrorProps> = ({
	button,
	mainTitle = DASHBOARD_ERROR_TITLE,
	secondaryMsg = DASHBOARD_ERROR_MSG,
	icon = ErrorLoadPageIcon,
	hideButton
}) => {
	return (
		<LoadErrorMsgLayout
			mainTitle={mainTitle}
			secondaryMsg={secondaryMsg}
			icon={icon}
			className="wfa-error"
		>
			{!hideButton ? button || <ContactUsButton product={ProductType.WEB_FLOW_ANALYZER} /> : null}
		</LoadErrorMsgLayout>
	);
};
